<template>
  <div @keyup.enter='$emit("ready")'>
    <h2>Alta de Establecimientos Vendedores</h2>
    <p>Siempre podrá dar de alta nuevos establecimientos una vez finalizado el proceso de registro de la Entidad. Podrá configurar los datos generales y perfil de calidad de su cuenta que aplican a todos los establecimientos.</p>

    <div class="establishment-list">
      <h3>
        Establecimientos vendedores
        <vs-button data-test="button-establishmentseller" @click="openPopup" color="success" type="border">Añadir</vs-button>
      </h3>

      <div id="alertStablishment" class="alert info" v-if="!sellerEstablishments.length">
        <vs-icon icon="error"></vs-icon>
        No existen establecimientos cargados. Deberá agregar al menos un establecimiento vendedor a través del botón agregar para poder continuar.
      </div>

      <div class="list" v-else>
        <div class="header">
          <div>Nombre</div>
          <div>Localidad</div>
          <div>Estado</div>
          <div></div>
        </div>

        <div class="content">
          <div class="establishment" :class="{inactive: !(sStab.status)}" v-for="(sStab, index) in sellerEstablishments" :key="sStab.id">
            <div>{{ sStab.name }}</div>
            <div>{{ sStab.city }}</div>
            <div><vs-switch :checked="sStab.status" color="success" @click="toggleStatusEstablishment({rol: 'seller', index: index})"/></div>
            <div class="actions">
              <button @click="removeEstablishment({rol: 'seller', name: sStab.name})">
                <vs-icon icon="delete"></vs-icon>
                <span>Borrar</span>
              </button>
              <button @click="editEstablishment(sStab.name)">
                <vs-icon icon="edit"></vs-icon>
                <span>Editar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <AddEditEstablishments ref="AddEditEstablishments" rol='seller'></AddEditEstablishments>
    </div>
  </div>

</template>

<script>
import { mapMutations, mapState } from 'vuex'
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import AddEditEstablishments from './AddEditEstablishment'

const fetchCountries = gql`
  query fetchCountries {
    fetchCountries {
      name
      id
    }
  }
`

const fetchStates = gql`
  query fetchStates($countryId: Int!) {
    fetchStates(countryId: $countryId) {
      name
      id
    }
  }
`

const fetchCities = gql`
  query fetchCities($stateId: Int!) {
    fetchCities(stateId: $stateId) {
      name
    }
  }
`

export default {
  name: 'signup-seller-establishments',
  components : {
    AddEditEstablishments
  },
  data () {
    return {
      activePopup: false,
      newEstablishment: { country: '', status: true },
      editing: '',
      countries: [],
      states: [],
      cities: [],
      number: ''
    }
  },
  computed: {
    ...mapState({
      sellerEstablishments: state => state.SignUp.establishments.seller
    })
  },
  beforeMount () {
    this.getCountries()
  },
  methods: {
    ...mapMutations('SignUp', [
      'pushEstablishment',
      'removeEstablishment',
      'toggleStatusEstablishment',
      'updateEstablishment'
    ]),
    editEstablishment (name) {
      this.$refs.AddEditEstablishments.editEstablishment(name)
    },
    getLocalizationId (arrayName, name) {
      return this[arrayName].find(q => q.name === name).id
    },
    getCountries () {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(fetchCountries)
      }}).then(res => {
        if (res.data.errors) {
          console.log(res.data.errors)
        } else {
          this.newEstablishment.state = ''
          this.newEstablishment.city = ''
          this.countries = res.data.data.fetchCountries
          this.getStates('Argentina')
        }
      })
    },
    getStates (countryName) {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(fetchStates),
        variables: {
          countryId: this.getLocalizationId('countries', countryName)
        }
      }}).then(res => {
        if (res.data.errors) {
          console.log(res.data.errors)
        } else {
          this.newEstablishment.city = ''
          this.states = res.data.data.fetchStates
        }
      })
    },
    getCities (stateName) {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(fetchCities),
        variables: {
          stateId: this.getLocalizationId('states', stateName)
        }
      }}).then(res => {
        if (res.data.errors) {
          console.log(res.data.errors)
        } else {
          this.cities = res.data.data.fetchCities
        }
      })
    },
    createSellerEstablishment () {
      this.$validator.validate().then((res) => {
        if (res) {
          if (!this.editing) {
            this.pushEstablishment({ rol: 'seller', value: this.newEstablishment })
          } else {
            this.updateEstablishment({ rol: 'seller', name: this.editing, value: this.newEstablishment })
          }
          this.dismissPopup()
          this.newEstablishment = { country: '', state: '', city: '', status: true }
          this.getCountries()
          this.editing = ''
        } else {
          return false
        }
      })
    },
    readyForNext () {
      if (this.sellerEstablishments.length < 1) {
        this.flashErrorStablishments()
      }
      return !!(this.sellerEstablishments.length)
    },
    dismissPopup () {
      this.activePopup = false
      this.newEstablishment = { country: '', state: '', city: '', status: true }
    },
    openPopup () {
      this.newEstablishment = { country: '', state: '', city: '', status: true }
      this.editing = ''
      this.activePopup = true
      this.$refs.AddEditEstablishments.openPopup()
    },
    flashErrorStablishments () {
      let alert = document.querySelector('#alertStablishment')
      alert.classList.remove('info')
      alert.classList.add('danger')
      alert.classList.add('pop')

      setTimeout(function () {
        alert.classList.add('info')
        alert.classList.remove('danger')
        alert.classList.remove('pop')
      }, 500)
    }
  }
}
</script>
